// extracted by mini-css-extract-plugin
module.exports = {"title":"immunohistochemistry-table-module__title___QaWeg","table":"immunohistochemistry-table-module__table___3X0qJ","cell":"immunohistochemistry-table-module__cell___3Hv6N"};